export default "__VITE_ASSET__DbsFhcsd__"